import React from 'react'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { NavLink } from '@/components/frontend/atoms/navigation/NavLink'

interface NavItem {
  label: string
  href: string
}

interface NavMenuProps {
  items: NavItem[]
  currentPath?: string
}

export const NavMenu: React.FC<NavMenuProps> = ({ items, currentPath }) => (
  <Inline gap="6">
    {items.map((item) => (
      <NavLink key={item.href} href={item.href} active={currentPath === item.href}>
        {item.label}
      </NavLink>
    ))}
  </Inline>
)
